import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import { useStrictLocalization } from "@faire/web--source/common/localization";

import { useSettingHeaderNavSignupCTACopy } from "@faire/retailer/settings/useSettingHeaderNavSignupCTACopy";

export const useHeaderSignUpCopy = () => {
  const setting = useSettingHeaderNavSignupCTACopy();
  const { strictLocalize } = useStrictLocalization();
  switch (setting) {
    case "CONTROL":
    case "BUCKET_UNKNOWN":
      return strictLocalize({
        defaultMessage: "Sign up to shop",
        description: { text: "CTA button to sign up" },
      });
    case "VARIANT_2":
      return strictLocalize({
        defaultMessage: "Join free",
        description: { text: "CTA button to sign up" },
      });
    case "VARIANT_3":
      return strictLocalize({
        defaultMessage: "Sign up",
        description: { text: "CTA button to sign up" },
      });
    case "VARIANT_4":
      return strictLocalize({
        defaultMessage: "Get started",
        description: { text: "CTA button to sign up" },
      });
    case "VARIANT_5":
      return strictLocalize({
        defaultMessage: "Sign up to buy",
        description: { text: "CTA button to sign up" },
      });
    default:
      return exhaustiveSwitchWithDefault("")(setting);
  }
};
